import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class Utils {
  constructor(private datePipe: DatePipe) {}

  convertDateFormat(data: string): string {
    return this.datePipe.transform(data, 'dd-MM-yyyy') as string;
  }

  convertDate(data: string): string {
    // Parse the date (assuming dd-mm-yyyy format)
    const parts = data.split('-');
    const parsedDate = new Date(`${parts[2]}-${parts[1]}-${parts[0]}`);

    // Format to mm-dd-yyyy
    return this.datePipe.transform(parsedDate, 'MM-dd-yyyy') as string;
  }
}
